"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnMemoryStore = void 0;
class OnMemoryStore {
  constructor(value = null) {
    this.value = value;
  }
  get() {
    return Promise.resolve(this.value);
  }
  set(value) {
    this.value = value;
    return Promise.resolve();
  }
  clear() {
    this.value = null;
  }
}
exports.OnMemoryStore = OnMemoryStore;
//# sourceMappingURL=Store.js.map